import { ReactNode } from 'react';
import styled from 'styled-components';

type BackgroundImageConfig = {
  image: string;
  position?: string;
  size?: string;
};

type BaseBackgroundImageProps = {
  className?: string;
  children: ReactNode;
};

type BackgroundImageProps = BaseBackgroundImageProps & {
  mobile: BackgroundImageConfig;
} & (
    | { tablet: BackgroundImageConfig; desktop?: BackgroundImageConfig }
    | { tablet?: BackgroundImageConfig; desktop: BackgroundImageConfig }
  );

const BackgroundImage = ({ className, children }: BaseBackgroundImageProps) => (
  <div className={className}>{children}</div>
);

const backgroundStyles = ({ image, position = 'top', size = 'auto' }: BackgroundImageConfig) => `
  background-image: url('${image}');
  background-position: ${position};
  background-size: ${size};
`;

const StyledBackgroundImage = styled(BackgroundImage)<BackgroundImageProps>`
  background-origin: content-box;
  background-repeat: no-repeat;

  ${({ desktop, mobile, tablet, theme }) => `
    ${backgroundStyles(mobile)}

    @media (min-width: ${theme.media.sm}) {
      ${tablet && backgroundStyles(tablet)}
    }

    @media (min-width: ${theme.media.md}) {
      ${desktop && backgroundStyles(desktop)}
    }
  `}
`;

export default StyledBackgroundImage;
